@if (cornerRadius) {
    <div class="agpr-block-cornerRadius" role="group"  [attr.aria-labelledby]="id + '_label'">
        <div class="agpr-block-cornerRadius-header">
            <span [id]="id + '_label'" class="agpr-block-cornerRadius-header-label--heading">
                {{ 'PageBuilder.formField.cornerRadius' | localize }}
                @if (showInfoTooltip) {
                    <span
                        class="agpr-block-cornerRadius-info fa-regular fa-circle-info"
                        aria-hidden="true"
                        [agprTooltip]="'PageBuilder.formField.cornerRadius.layoutInfo'"
                    ></span>
                }
            </span>
            <agpr-checkbox
                [id]="id + '_moreOptions'"
                [label]="'PageBuilder.formField.cornerRadius.moreOption' | localize"
                [binary]="true"
                [(ngModel)]="cornerRadius.cornerRadiusOption"
                (ngModelChange)="optionChange($event)"
            ></agpr-checkbox>
        </div>
        <div *ngIf="!cornerRadius.cornerRadiusOption" class="agpr-block-cornerRadius-all">
            <agpr-number-input
                [id]="id + '_all'"
                [min]="0"
                [max]="1000"
                [(ngModel)]="cornerRadius.cornerRadiusAll"
                (ngModelChange)="onValueChange()"
                unit="px"
                [integerOnly]="true"
            ></agpr-number-input>
        </div>
        <div *ngIf="cornerRadius.cornerRadiusOption">
            <div class="agpr-block-cornerRadius-row">
                <agpr-number-input
                    [id]="id + '_top'"
                    [label]="'PageBuilder.formField.cornerRadius.topLeft' | localize"
                    [(ngModel)]="cornerRadius.topLeftCornerRadius"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="1000"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
                <agpr-number-input
                    [id]="id + '_left'"
                    *ngIf="!verticalOnly"
                    [label]="'PageBuilder.formField.cornerRadius.topRight' | localize"
                    [(ngModel)]="cornerRadius.topRightCornerRadius"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="1000"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
                <agpr-number-input
                    [id]="id + '_bottom'"
                    *ngIf="verticalOnly"
                    [label]="'PageBuilder.formField.cornerRadius.bottomLeft' | localize"
                    [(ngModel)]="cornerRadius.bottomLeftCornerRadius"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="1000"
                    unit="px"
                    [integerOnly]="true"
            ></agpr-number-input>
            </div>
            <div
                *ngIf="!verticalOnly"
                class="agpr-block-cornerRadius-row">
                <agpr-number-input
                    [id]="id + '_bottom'"
                    [label]="'PageBuilder.formField.cornerRadius.bottomLeft' | localize"
                    [(ngModel)]="cornerRadius.bottomLeftCornerRadius"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="1000"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
                <agpr-number-input
                    [id]="id + '_right'"
                    [label]="'PageBuilder.formField.cornerRadius.bottomRight' | localize"
                    [(ngModel)]="cornerRadius.bottomRightCornerRadius"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="1000"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
            </div>
        </div>
    </div>
}
